import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

let lightbox: PhotoSwipeLightbox | null = null;

export function initializePhotoSwipe() {
  // Opret PhotoSwipe Lightbox-instans for .ug-gallery
  lightbox = new PhotoSwipeLightbox({
    gallery: "#ug-gallery",
    children: "a",
    pswpModule: () => import("photoswipe"),
    bgOpacity: 0.9,
    padding: { top: 20, bottom: 40, left: 0, right: 0 },
    showHideAnimationType: "fade",
    zoom: true,
    counter: false,
    preloaderDelay: 1000,
  });

  // Initialiser lightboxen
  lightbox.init();

  // Tilføj klik-begivenhedslytter til thumbnails
  document.querySelectorAll("#ug-gallery a").forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", (e) => {
      e.preventDefault();
      if (lightbox) {
        lightbox.loadAndOpen(index); // Åbn lightboxen på det klikkede thumbnail
      }
    });
  });
}

// Funktion til at ødelægge PhotoSwipe-instansen
export function destroyPhotoSwipe() {
  if (lightbox) {
    lightbox.destroy();
    lightbox = null;
  }
}
